// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"style_searchInput__3MDN4","info":"style_info__1B2jP"};